/* esm.sh - micromark@4.0.3/lib/postprocess */
import{subtokenize as r}from"/micromark-util-subtokenize@^2.0.0?target=denonext";function e(o){for(;!r(o););return o}export{e as postprocess};
//# sourceMappingURL=postprocess.mjs.map